import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-ink',
  tint: 'bg-blue-50 text-ink',
  deep: 'bg-petrol text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-164" data-mp="2pv8aksukfbn">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-narrow' : 'max-w-content'}`} data-id="element-165" data-mp="2nr74amc1uf2">
        {hasHeader && <header className="mx-auto max-w-narrow text-center" data-id="element-166" data-mp="vcy598hvkhzs">
            {eyebrow && <p className={`mb-4 font-display text-xs font-extrabold uppercase tracking-[0.18em] ${tone === 'deep' ? 'text-blue-200' : 'text-blue-600'}`} data-id="element-167" data-mp="1060zzjye1xhk">
                {eyebrow}
              </p>}
            {title && <h2 className="font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight md:text-5xl" data-id="element-168" data-mp="38egkjsp7eiyk">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${tone === 'deep' ? 'text-blue-100' : 'text-blue-900/70'}`} data-id="element-169" data-mp="3i9ryw9wp9o5s">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-170" data-mp="3n9wgk39cgoxl">{children}</div>
      </div>
    </section>;
}